var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.6715 7.13625C21.1913 6.53713 21.5877 5.84123 21.8378 5.08851C22.0879 4.33579 22.1869 3.54108 22.129 2.75C20.5331 2.87882 19.0517 3.62939 18.004 4.84C17.5023 5.42022 17.122 6.09521 16.8859 6.82501C16.6497 7.55481 16.5623 8.32458 16.629 9.08875C17.4074 9.09524 18.1769 8.92251 18.8779 8.58393C19.5789 8.24535 20.1926 7.75001 20.6715 7.13625ZM24.1365 17.3663C24.1457 16.3126 24.4232 15.2788 24.9429 14.3622C25.4625 13.4456 26.2072 12.6765 27.1065 12.1275C26.5389 11.3097 25.7886 10.6354 24.9151 10.1581C24.0415 9.68071 23.0688 9.41346 22.074 9.3775C19.929 9.1575 17.949 10.6287 16.8077 10.6287C15.6665 10.6287 14.0577 9.405 12.2702 9.4325C11.1017 9.47099 9.96303 9.8117 8.96536 10.4214C7.9677 11.0311 7.14508 11.8889 6.57775 12.9113C4.15775 17.1188 5.959 23.375 8.379 26.7712C9.479 28.435 10.854 30.3188 12.669 30.25C14.484 30.1812 15.0752 29.1225 17.179 29.1225C19.2827 29.1225 19.929 30.25 21.7165 30.2087C23.504 30.1675 24.769 28.5037 25.924 26.84C26.7422 25.6321 27.3813 24.3122 27.8215 22.9212C26.7318 22.4565 25.8021 21.6828 25.1472 20.6956C24.4923 19.7083 24.1409 18.5509 24.1365 17.3663Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.026e9f60cde07ecfac68f1b23b0d3ad2.svg";
export { ForwardRef as ReactComponent };